import React from 'react';

import _ from "lodash";
import EntityReport from '../components/reports';

import { prepareRequest } from "../../../services/report.service";
import { localizedStrings } from '../../../../localization/index';
import styles from "../reports.module.scss";
import Actions from 'src/components/actionbar';

export default class PerformanceDetailReport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      request: null,
      viewMore: false,
    }

    this.handleViewMoreClicked = this.handleViewMoreClicked.bind(this);

    this.localizedReport = localizedStrings.pages.reports;
  }


  componentDidMount() {
    this.loadReport(this.props.request, 0, 5);
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.request, nextProps.request)) {
      this.loadReport(nextProps.request, 0, 5);
    }
  }

  loadReport(request, page, limit) {
    if (!request) {
      return;
    }

    const processedRequest = prepareRequest(request, this.props.supportedEntities);
    if (!_.isEqual(this.state.request, processedRequest)) {
      this.setState({
        request: processedRequest
      }, () => {
        this.props.fetchData(processedRequest, page, limit);
      })
    }
  }

  handleViewMoreClicked() {
    this.setState({
      viewMore: true
    })
  }

  render() {
    var count = (_.get(this.props.data, 'items') || []).length;
    var pages = _.get(this.props.data, 'pagination.totalPages');
    var empty = count == 0;
    var hasMore = pages > 1;

    return (
      <div className={styles.detailsReport}>

        <span className={styles.viewMoreButton} onClick={this.handleViewMoreClicked}>
           <i className="paperflite-right-arrow"/> view more
        </span>
        <EntityReport.Popup
          id={this.props.id}
          show={this.state.viewMore}
          title={this.props.title}
          icon={this.props.icon}
          className={this.props.className}
          {...this.props.grid}
          request={this.state.request}
          data={this.props.data}
          fetchData={this.props.fetchData}
          onClose={() => {
            this.setState({ viewMore: false })
          }}
          downloadProperties={this.props.downloadProperties}
          tooltipText={this.props.tooltipText}
        />
      </div>
    );
  }
}